import { branch, compose, withContext, withProps } from 'recompose'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { withQueryParams } from 'src/composables'
import {
  selectCustomerProfile,
  selectCustomerIsREA,
  selectInstantOfferEnabled
} from 'src/store/selectors/customerProfile'
import {
  selectHomeAddressStateName,
  selectWarnings
} from 'src/store/selectors/home'
import { selectCurrentAVM } from 'src/store/selectors/home/avm'
import { selectHasCMA } from 'src/store/selectors/home/cma'
import { toggleWarningModal } from 'src/actions/homeowner'
import { selectCurrentAVMMap } from 'src/store/selectors/homePreview'
import { selectHomeData } from 'src/store/selectors/home'
import { redrawHeightFadeKey } from 'src/actions/transitions'

const defaultProps = withProps(props => ({
  withCurrentHomeData: get(props, 'withCurrentHomeData', false),
  locked: false
}))

const provideContext = withContext(
  { withCurrentHomeData: PropTypes.bool, locked: PropTypes.bool },
  ({ withCurrentHomeData, locked }) => ({ withCurrentHomeData, locked })
)

const composeWithHomeData = compose(
  connect(
    state => ({
      ...selectWarnings(state),
      customerProfile: selectCustomerProfile(state) || {},
      instantOfferEnabled: selectInstantOfferEnabled(state),
      customerIsREA: selectCustomerIsREA(state),
      hasCMA: selectHasCMA(state),
      avm: selectCurrentAVM(state),
      home: selectHomeData(state),
      stateName: selectHomeAddressStateName(state)
    }),
    dispatch => ({
      redrawHeightFade: (id, speed) => dispatch(redrawHeightFadeKey(id, speed)),
      toggleWarningModal: () => dispatch(toggleWarningModal())
    })
  ),
  withProps(({ customerIsREA }) => ({
    showAvatarOnVerifyButton: customerIsREA
  }))
)

const composeWithoutHomeData = compose(
  withQueryParams,
  connect((state, { id }) => {
    const avm = selectCurrentAVMMap(state)[id]

    return {
      customerProfile: selectCustomerProfile(state) || {},
      hasCMA: false,
      instantOfferEnabled: false,
      avm: get(avm, 'amount')
    }
  })
)

const EstimatedValueContainer = compose(
  defaultProps,
  provideContext,
  branch(
    ({ withCurrentHomeData }) => withCurrentHomeData,
    composeWithHomeData,
    composeWithoutHomeData
  )
)

export default EstimatedValueContainer
